import AreaPage from "@/components/AreaPage";

const area = {
  name: "Sector 49-50",
  slug: "water-tank-cleaning-sector-49-50-gurugram",
  h1: "Water Tank Cleaning in Sector 49 & 50, Gurugram",
  description: "Water tank cleaning in Sector 49 and Sector 50 Gurugram. Apartments, builder floors, and societies served. Starting ₹999.",
  content1: "Sector 49 and Sector 50 in Gurugram are vibrant residential areas with a healthy mix of apartments, builder floors, group housing societies, and commercial establishments. TankBuddy provides reliable water tank cleaning for all property types in these sectors — from individual 500-litre rooftop tanks to 20,000-litre society tanks serving hundreds of families.",
  content2: "These sectors benefit from proximity to Sohna Road and Golf Course Extension, but also face water quality challenges due to mixed supply sources. Regular professional cleaning every 6 months keeps your water safe and your tanks in optimal condition. TankBuddy offers same-day service for urgent requirements and discounted rates for RWA bulk bookings. Call us today for a free assessment.",
  nearby: [
    { href: "/water-tank-cleaning-sohna-road-gurugram", label: "Sohna Road" },
    { href: "/water-tank-cleaning-golf-course-road-gurugram", label: "Golf Course Road" },
    { href: "/water-tank-cleaning-nirvana-country-gurugram", label: "Nirvana Country" },
    { href: "/water-tank-cleaning-sector-56-57-gurugram", label: "Sector 56-57" },
  ],
};

export default function Sector4950Page() {
  return <AreaPage area={area} />;
}
